import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileEditComponent } from './profile-edit/profile-edit.component'
import { ProfileRoutingModule } from './profile-routing.module';
import { PasswordChangeComponent } from './password-change/password-change.component';
import { SharedModule } from '../../common/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';

const declarations = [
    PasswordChangeComponent,
    ProfileEditComponent,
];

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ProfileRoutingModule,
        SharedModule,
    ],
    declarations: [
        ...declarations,
    ],
    exports: [
        ...declarations
    ]
})
export class ProfileModule {
}
